import { Link } from '@revdotcom/vaporwave';

import styles from '../../styles';

/**
 * Renders terms and privacy links under login flow cards
 * @param {object} props properties
 * @param {Record<string, string>} props.viewData view data passed from the page
 * @returns {Element} links element
 */
export const UnderLinks = (props: { viewData: Record<string, string> }) => {
    const termsLink = props.viewData['terms-link'];
    const privacyLink = props.viewData['privacy-link'];
    const caPrivacyLink = props.viewData['ca-privacy-link'];
    const hasUnderLinks = termsLink || privacyLink || caPrivacyLink;

    if (!hasUnderLinks) return <></>;

    return (
        <div sx={styles.cardUnderLinks}>
            {termsLink && (
                <Link sx={styles.cardUnderLink} href={termsLink}>
                    Terms
                </Link>
            )}
            {privacyLink && (
                <Link sx={styles.cardUnderLink} href={privacyLink}>
                    Privacy
                </Link>
            )}
            {caPrivacyLink && (
                <Link sx={styles.cardUnderLink} href={caPrivacyLink}>
                    CA Privacy
                </Link>
            )}
        </div>
    );
};
